<template>
<transition name="burger-fade">
  <div class="cookies-bar" v-if="showCookies">
      <div class="text-box">
          <span class="ttl bold-italic f-21">{{$fn.tr('ქუქის პოლიტიკა')}}</span>
          <span class="light-italic f-16">{{$fn.tr('ეს საიტი იყენებს cookies და მასთან დაკავშირებულ ტექნოლოგიებს საიტის მუშაობის.')}} <router-link :to="getPrivacyLink" class="bold-italic f-16"> {{$fn.tr('კონფიდენციალურობა')}}</router-link></span>
      </div>
      <div class="btns-wrapper">
      <div class="accept-btn pointer" @click.once="toggleCookies()">
          <div class="icon">
            <svg id="Component_6_18" data-name="Component 6 – 18" xmlns="http://www.w3.org/2000/svg" width="265.37" height="60" viewBox="0 0 265.37 60">
              <path id="Path_305" data-name="Path 305" d="M620.561,180.644c5.355,2.522,22.819,2.365,28.207,3.694s35.485,1.49,29.472,1.341,37.878,2.142,33.062,2.022-26.491-.071-4.816-.12,14.476-.831,16.264-.189,13.936-3.227,20.535-2.467,13.362-4.429,27.142-1.7,28.279.714,35.5.894,2.974,1.269,2.974,1.269a70.175,70.175,0,0,1,8.395,1.4c1.79.645,6.62.17,6.62.17s3.7-3.485,3.011.074.644-1.773-.7,3.561,2.444-1.133-.8,7.737,1.7,4.215-3.239,8.863-6.651,1.025-4.934,4.648-3.7,3.487-.835,8.923,2.8,8.418,2.751,10.208-31.49,6.96-38.155,8.582-42.648-4.056-59.574-1.5-14.287-6.327-34.146-6.825-22.791-3.556-22.791-3.556a67.6,67.6,0,0,0-11.434-.288c-4.225.488-20.47.076-10.848.325s-.6-.018-4.255,1.679-4.8-.716-31.969,2.177-41.583,1.34-41.583,1.34l-2.776-9.017,4.425-8.239s.214-8.345.291-11.325,3.96-13.617,3.96-13.617-3.995-8.448,6.834-8.177,16.3-1.38,19.905-1.288,13.885-1.44,15.692-1.4,7.806.792,7.806.792" transform="translate(-561.648 -179.851)" fill="#fcfdff" fill-rule="evenodd"/>
            </svg>
          </div>
          <span class="f-16 bold-italic">{{$fn.tr('დადასტურება')}}</span>
      </div>
      <div class="x-btn pointer" @click.once="toggleCookies()">
          <svg xmlns="http://www.w3.org/2000/svg" width="23.084" height="23.867" viewBox="0 0 23.084 23.867">
  <g id="Group_240" data-name="Group 240" transform="translate(-1721.82 -107.436)">
    <path id="Path_1643" data-name="Path 1643" d="M1.176,3.99c5.216.124,10.33-.884,15.532-.967,3.182-.05,6.649.417,9.751-.5.771-.228,1.719-.67,1.683-1.6l0-.113c-.035-.9-1.7-.874-2.862-.308-2.825.633-6.042.035-8.89.171C11.8.9,7.267,1.715,2.663,1.605,1.078,1.568-1.507,3.927,1.176,3.99Z" transform="translate(1724.733 107.353) rotate(45)" fill="#101820"/>
    <path id="Path_1644" data-name="Path 1644" d="M25.334.159c-3.173,1.572-7,1.467-10.436,1.307A107.346,107.346,0,0,1,2.62.344C.7.032-1.407,2.765,1.234,3.194A95.955,95.955,0,0,0,16.055,4.4c3.748.019,7.584-.253,11.007-1.948C29.489,1.245,27.331-.83,25.334.159Z" transform="translate(1721.897 128.187) rotate(-45)" fill="#101820"/>
  </g>
</svg>

      </div>
      </div>



   
      <div class="accept-btn pointer lg-only" @click.once="toggleCookies(); yes();">
         <div class="icon">
            <svg id="Component_6_18" data-name="Component 6 – 18" xmlns="http://www.w3.org/2000/svg" width="265.37" height="60" viewBox="0 0 265.37 60">
              <path id="Path_305" data-name="Path 305" d="M620.561,180.644c5.355,2.522,22.819,2.365,28.207,3.694s35.485,1.49,29.472,1.341,37.878,2.142,33.062,2.022-26.491-.071-4.816-.12,14.476-.831,16.264-.189,13.936-3.227,20.535-2.467,13.362-4.429,27.142-1.7,28.279.714,35.5.894,2.974,1.269,2.974,1.269a70.175,70.175,0,0,1,8.395,1.4c1.79.645,6.62.17,6.62.17s3.7-3.485,3.011.074.644-1.773-.7,3.561,2.444-1.133-.8,7.737,1.7,4.215-3.239,8.863-6.651,1.025-4.934,4.648-3.7,3.487-.835,8.923,2.8,8.418,2.751,10.208-31.49,6.96-38.155,8.582-42.648-4.056-59.574-1.5-14.287-6.327-34.146-6.825-22.791-3.556-22.791-3.556a67.6,67.6,0,0,0-11.434-.288c-4.225.488-20.47.076-10.848.325s-.6-.018-4.255,1.679-4.8-.716-31.969,2.177-41.583,1.34-41.583,1.34l-2.776-9.017,4.425-8.239s.214-8.345.291-11.325,3.96-13.617,3.96-13.617-3.995-8.448,6.834-8.177,16.3-1.38,19.905-1.288,13.885-1.44,15.692-1.4,7.806.792,7.806.792" transform="translate(-561.648 -179.851)" fill="#fcfdff" fill-rule="evenodd"/>
            </svg>
          </div>
          <span class="f-16 bold-italic">{{$fn.tr('დადასტურება')}}</span>
      </div>
      <div class="x-btn pointer lg-only" @click.once="toggleCookies()">
          <svg xmlns="http://www.w3.org/2000/svg" width="23.084" height="23.867" viewBox="0 0 23.084 23.867">
  <g id="Group_240" data-name="Group 240" transform="translate(-1721.82 -107.436)">
    <path id="Path_1643" data-name="Path 1643" d="M1.176,3.99c5.216.124,10.33-.884,15.532-.967,3.182-.05,6.649.417,9.751-.5.771-.228,1.719-.67,1.683-1.6l0-.113c-.035-.9-1.7-.874-2.862-.308-2.825.633-6.042.035-8.89.171C11.8.9,7.267,1.715,2.663,1.605,1.078,1.568-1.507,3.927,1.176,3.99Z" transform="translate(1724.733 107.353) rotate(45)" fill="#101820"/>
    <path id="Path_1644" data-name="Path 1644" d="M25.334.159c-3.173,1.572-7,1.467-10.436,1.307A107.346,107.346,0,0,1,2.62.344C.7.032-1.407,2.765,1.234,3.194A95.955,95.955,0,0,0,16.055,4.4c3.748.019,7.584-.253,11.007-1.948C29.489,1.245,27.331-.83,25.334.159Z" transform="translate(1721.897 128.187) rotate(-45)" fill="#101820"/>
  </g>
</svg>

      </div>
    
  </div>
  </transition>
</template>

<script>
export default {
  data(){
    return{
      showCookies: true,
      
    }
  },
  created(){
      if(!localStorage.getItem('acceptedCookies')){
          this.showCookies = true;
        } else {
          this.showCookies= false;
        }
  },
  mounted(){
        // console.log(this.getPrivacyLink)
      
  },
  computed: {
    getPrivacyLink(){
      let b = this.$store.state.main.indx.menus;
      let f;
      let _f;

      f = b.filter(__b => __b.configs.includes("cookies"));

      _f = f[0].full_url;




      return _f;
    }
  },
  methods: {
    toggleCookies(){
      this.showCookies = !this.showCookies;
    },
        yes(){
    
        localStorage.setItem('acceptedCookies', true);
        this.showCookies = false;
    }
  },
}
</script>

<style>

</style>